module.exports = __webpack_public_path__ + "static/media/404.ae26478b.svg";